import React from "react";
import styled from "styled-components";

const Dealership = () => {
  return (
    <Wrapper id="dealership" name="dealership">
      <div className="content">
        <h2 className="main-heading-delearship">Exclusive Dealership</h2>
        <div className="dealership-content">
          <div className="left">
          <img
                src={`${process.env.PUBLIC_URL}/handshake.jpg`}
                className="card-img-top"
                alt="..."
              />
          </div>
          <div className="right">
            <p className="dealership-desc">

          At MShine Enterprises, we are proud to offer exclusive dealership
          opportunities across Karnataka for high-quality AdBlue and radiator
          coolant products.<br/><br/> Our mission is to support a cleaner environment and
          improve vehicle performance through our premium range of automotive
          fluids.
        </p>
        
        
        </div>

        <div className="dealership-benifit-section">
          <div className="benifits">
            <div className="left-benifit">
            <img
                src={`${process.env.PUBLIC_URL}/trophy.png`}
                className="trophy"
                alt="..."
              />
            </div>
            <div className="right-benifit">
            <span className="right-benifit-heading">Competitive Margins</span><br></br>
            <p className="right-benifit-content">Enjoy discounted margins to maximize your profitability.</p>
            </div>
          </div>

          <div className="benifits">
            <div className="left-benifit">
            <img
                src={`${process.env.PUBLIC_URL}/trophy.png`}
                className="trophy"
                alt="..."
              />
            </div>
            <div className="right-benifit">
            <span className="right-benifit-heading">Comprehensive Support</span><br></br>
            <p className="right-benifit-content">We offer full support to help you succeed in your region</p>
            </div>
          </div>

          <div className="benifits">
            <div className="left-benifit">
            <img
                src={`${process.env.PUBLIC_URL}/trophy.png`}
                className="trophy"
                alt="..."
              />
            </div>
            <div className="right-benifit">
            <span className="right-benifit-heading">Reliable Supply Chain</span><br></br>
            <p className="right-benifit-content">Count on timely deliveries to keep your inventory stocked</p>
            </div>
          </div>
          
        </div>
        </div>
        
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
    background: linear-gradient(to right, #e5b029, #fff);
  padding: 4rem 2rem;
  /* text-align: center; */
  font-family: 'Inter';
  

  .trophy{
    height: 50px;
    width: 50px;
  }

  .benifits{
    /* border: 1px solid black; */
    width: 80%;
   margin: 1px 20px;
   /* height: 50px; */
   padding-left: 10px;
  display: flex;
  }

  .main-heading-delearship{
    position: relative;
    text-align: center;
  }

  .content {
    /* max-width: 800px; */
    margin: 0 auto;
  }

  
  h2 {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
    color: #333;
    text-transform: uppercase;
    font-family: "Play", sans-serif;
    font-optical-sizing: auto;
    font-weight: 900;
    font-style: italic;
  }

  .dealership-content{
    width: 100%;
    display: flex;
  }

  .dealership-desc{
    font-size: 1.1rem;
    font-family:'Play';
    font-weight: 400;
    text-align: left;
    padding: 1px 20px;
    text-align: center;
   
  }

  .left{
    width: 40%;
    /* border: 1px solid black; */
  display: flex;
  }

  .left img{
    border-radius: 10px;
    max-height: 250px;
  }

  .right{
    width: 40%;
    display: flex;
    align-items: center;
  }

  .left-benifit{
    display: flex;
    align-items: center;
  }

  .right-benifit{
    padding-left: 20px;
    padding-top: 20px;
   
  }

  .right-benifit-heading{
    font-weight: 500;
    text-transform: uppercase;
  }

  .right-benifit-content{
    font-size: 0.8rem;
    line-height: normal;
  }



  @media (max-width: 768px) {
    padding: 2rem 1rem;

    h2 {
      font-size: 2rem;
    }

    p {
      font-size: 1rem;
    }

    .dealership-content{
      flex-direction: column;
      justify-content: center;
        align-items: center;
    }
    .left{
      width: 80%;
    }
    .right{
      width: 80%;
    }
  }

  @media (orientation: landscape) and (max-width: 992px) {
    .dealership-content {
      flex-direction: column; /* Stack vertically */
      align-items: center; /* Center align */
    }

    .left,
    .right {
      width: 90%; /* Adjust width for better layout in landscape mode */
      margin-bottom: 20px; /* Add space between sections */
    }
  }


`;

export default Dealership;
